import React, { Component } from 'react';

export const DynamicWrapper = ({ wrapper, ...props }) => {
  return React.cloneElement(wrapper, { ...props });
};
